//tasks-day-harvest-section.tsx

import { Box, Typography } from "@mui/material";
import TaskGrid from "../task-grid";
import { HarvestTaskRow } from "../../types/task-rows";
import { Tasks } from "../../models/tasks";

interface TasksDayHarvestSectionProps {
  rows: HarvestTaskRow[];
  harvestColumns: any;
  harvestColumnOptions: any;
  periodTasksTag?: number;
  periodTasks: Tasks[];
  title: string;
}

export default function TasksDayHarvestSection({
  rows,
  harvestColumns,
  harvestColumnOptions,
  periodTasksTag,
  periodTasks,
  title,
}: TasksDayHarvestSectionProps) {
  const trayTotal = periodTasks[0].harvest.reduce((sum, t) => sum + t.trays, 0);

  return (
    <Box>
      <Typography
        variant="h4"
        color="primary"
        sx={{
          pt: 4,
          display: "flex",
          alignItems: "end",
          justifyContent: "space-between",
        }}
      >
        {title}
        {rows.length > 0 && (
          <Typography sx={{ float: "right" }} color="black" variant="body1">
            <strong>Trays to Harvest Total: {trayTotal}</strong>
          </Typography>
        )}
      </Typography>

      <TaskGrid
        key={periodTasksTag}
        taskKey="harvest"
        rows={rows}
        baseColumns={harvestColumns}
        columnOptions={harvestColumnOptions}
        rowClassName={(params) => {
          return params.row.batchClass || "";
        }}
      />
    </Box>
  );
}
